module.exports = __webpack_public_path__ + "a0c0c3030bb6989f5b467de3f1215ecc.pdf";